import { useState, useRef } from 'react'
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    Button
} from '@mui/material'
import { BoxProps } from '@mui/system'

import { Link2, Unlink2 } from 'lucide-react'

import { usePreviewerContext } from './../context/PreviewerContextProvider'

const ChangePreviewUrlIconButton = (props: BoxProps): JSX.Element | null => {
    const { previewHasCustomUrl, previewUrl, setPreviewUrl } = usePreviewerContext()
    const [open, setOpen] = useState<boolean>(false)
    const previewUrlTextField = useRef<HTMLInputElement>()

    const handleClickOpen = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false)
    };

    const saveUrl = () => {
        if(previewUrlTextField?.current?.value){
            setPreviewUrl(previewUrlTextField?.current?.value);
        }else {
            setPreviewUrl()
        }
        
        handleClose()
    };

    const resetToAccept = () => {
        setPreviewUrl()
        handleClose()
    }

    return (
        <>
            <IconButton
                id="toggle-preview"
                onClick={handleClickOpen}
                sx={{
                    borderRadius: 2,
                    backgroundColor: previewHasCustomUrl ? 'orange' : undefined
                }}
            >
                {previewHasCustomUrl ? <Unlink2 /> : <Link2 />}
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Preview url</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Change the html previewer to use an different URL in the iframe. This is used for "preview branch" testing.

                        <br />
                        <strong>Current Url: {previewUrl}</strong>
                    </DialogContentText>
                    <br />
                    <TextField
                        autoFocus
                        inputRef={previewUrlTextField}
                        id="preview-build-url"
                        label="Preview build url"
                        type="string"
                        fullWidth
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    <Button variant="contained" color='secondary' onClick={resetToAccept}>Reset to Accept</Button>
                    <Button variant="contained" onClick={saveUrl}>Save Url</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ChangePreviewUrlIconButton
